<div class="packs">
  <header class="packs__header ps__header">
    <div>
      <h1 class="packs__title">
        <span class="packs__title-icon">
          <i class="fa-solid fa-route" aria-hidden="true"></i>
        </span>
        {{ 'PATH_SUBJECTS.TITLE' | translate }}
      </h1>
      <p class="packs__subtitle">{{ 'PATH_SUBJECTS.SUBTITLE' | translate }}</p>
    </div>

    <!-- L'ajout ne dépend d'aucun filtre : il est là que la recherche trouve
         quelque chose ou non, et que la liste soit vide ou pleine. -->
    <button type="button" class="packs__btn packs__btn--primary" (click)="openNewPath()">
      <i class="fa-solid fa-plus" aria-hidden="true"></i>
      {{ 'ADMIN.ADD_PATH' | translate }}
    </button>
  </header>

  @if (loading()) {
    <p class="packs__state" role="status">{{ 'COMMON.LOADING' | translate }}</p>
  } @else if (failed()) {
    <app-error-state (retry)="load()" />
  } @else if (paths().length === 0) {
    <app-empty-state icon="route" titleKey="ADMIN.NO_PATHS_FOUND" messageKey="PATH_SUBJECTS.EMPTY_HINT" />
  } @else {
    <div class="packs__layout">

      <!-- Les parcours, groupés par cycle : une vingtaine de classes de la
           1ère année au bac se parcourent mal en liste plate. -->
      <nav class="ps__nav" [attr.aria-label]="'PATH_SUBJECTS.TITLE' | translate">
        <label class="packs__field">
          <span>{{ 'PATH_SUBJECTS.SEARCH' | translate }}</span>
          <input type="search" name="search" autocomplete="off"
                 [ngModel]="search()" (ngModelChange)="search.set($event)" />
        </label>

        @for (group of groups(); track group.cycle) {
          <section class="ps__cycle">
            <h2 class="packs__group-title">{{ cycleLabelKey(group.cycle) | translate }}</h2>
            <div class="packs__list">
              @for (entry of group.paths; track entry.path.id) {
                <button type="button" class="packs__card"
                        [class.is-active]="selectedId() === entry.path.id"
                        [attr.aria-current]="selectedId() === entry.path.id ? 'true' : null"
                        (click)="select(entry.path)">
                  <span class="packs__card-name">{{ entry.path.title }}</span>
                  <span class="ps__count">
                    {{ 'PATH_SUBJECTS.ACTIVE_COUNT' | translate: { active: entry.activeSubjects, total: entry.totalSubjects } }}
                  </span>
                  @if (entry.path.status !== 'published') {
                    <span class="packs__card-flags">
                      <span class="packs__flag packs__flag--star">{{ 'ADMIN.DRAFT' | translate }}</span>
                    </span>
                  }
                </button>
              }
            </div>
          </section>
        } @empty {
          <p class="packs__hint" role="status">{{ 'PATH_SUBJECTS.NO_MATCH' | translate }}</p>
        }
      </nav>

      @if (selected(); as path) {
        <div class="packs__detail">

          <section class="packs__panel">
            <div class="packs__panel-head ps__panel-head">
              <h2 class="packs__panel-title">{{ 'PATH_SUBJECTS.PATH_PANEL' | translate }}</h2>
              @if (dirty()) {
                <span class="packs__dirty">{{ 'PATH_SUBJECTS.UNSAVED' | translate }}</span>
              }
            </div>

            <form (ngSubmit)="savePath()">
              <ng-container *ngTemplateOutlet="pathFields; context: { $implicit: draft(), target: 'current' }" />

              <div class="packs__toggles">
                <button type="submit" class="packs__btn packs__btn--primary"
                        [disabled]="savingPath() || !dirty()">
                  <i class="fa-solid fa-floppy-disk" aria-hidden="true"></i>
                  {{ 'PATH_SUBJECTS.SAVE_PATH' | translate }}
                </button>
                <button type="button" class="packs__btn ps__btn--danger" (click)="deletePath(path)">
                  <i class="fa-solid fa-trash-can" aria-hidden="true"></i>
                  {{ 'PATH_SUBJECTS.DELETE_PATH' | translate }}
                </button>
              </div>
            </form>
          </section>

          <section class="packs__panel">
            <div class="packs__panel-head ps__panel-head">
              <h2 class="packs__panel-title">{{ 'PATH_SUBJECTS.SUBJECTS_PANEL' | translate }}</h2>
              <button type="button" class="packs__btn" (click)="openAddSubject(path)">
                <i class="fa-solid fa-plus" aria-hidden="true"></i>
                {{ 'ADMIN.ADD_SUBJECT' | translate }}
              </button>
            </div>
            <p class="packs__hint">{{ 'PATH_SUBJECTS.INACTIVE_HINT' | translate }}</p>

            @if (subjects().length === 0) {
              <p class="packs__state">{{ 'ADMIN.NO_SUBJECTS_FOUND' | translate }}</p>
            } @else {
              <div class="packs__table-wrap">
                <table class="packs__table">
                  <thead>
                    <tr>
                      <th scope="col">{{ 'PATH_SUBJECTS.COL_ORDER' | translate }}</th>
                      <th scope="col">{{ 'PATH_SUBJECTS.COL_SUBJECT' | translate }}</th>
                      <th scope="col">{{ 'ADMIN.STATUS' | translate }}</th>
                      <th scope="col" class="packs__num">
                        <span class="packs__sr-only">{{ 'DATA_TABLE.ACTIONS' | translate }}</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (subject of subjects(); track subject.id) {
                      <tr [class.ps__row--off]="!subject.isActive">
                        <td class="packs__num ps__order" [attr.data-label]="'PATH_SUBJECTS.COL_ORDER' | translate">
                          {{ subject.displayOrder }}
                        </td>
                        <th scope="row" class="packs__subject">
                          <span class="ps__name">{{ subject.name }}</span>
                          <!-- Les trois libellés tels que le site les affichera ;
                               un tiret dit qu'il retombera sur le nom. -->
                          <span class="ps__labels">
                            <span dir="rtl" lang="ar">{{ subject.nameAr || '—' }}</span>
                            <span lang="fr">{{ subject.nameFr || '—' }}</span>
                            <span lang="en">{{ subject.nameEn || '—' }}</span>
                          </span>
                        </th>
                        <td class="packs__num ps__state" [attr.data-label]="'ADMIN.STATUS' | translate">
                          <label class="ps__switch">
                            <input type="checkbox" role="switch"
                                   [checked]="subject.isActive"
                                   [disabled]="isToggling(subject.id)"
                                   [attr.aria-label]="'PATH_SUBJECTS.TOGGLE' | translate: { name: subject.name }"
                                   (change)="toggleSubject(subject, $any($event.target).checked)" />
                            <span class="ps__switch-track" aria-hidden="true"></span>
                            <!-- Le mot répète ce que dit la couleur : elle seule
                                 ne porte jamais une information. -->
                            <span class="ps__switch-text">
                              @if (isToggling(subject.id)) {
                                <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
                              }
                              {{ (subject.isActive ? 'PATH_SUBJECTS.ACTIVE' : 'PATH_SUBJECTS.INACTIVE') | translate }}
                            </span>
                          </label>
                        </td>
                        <td class="packs__num ps__actions" [attr.data-label]="'DATA_TABLE.ACTIONS' | translate">
                          <button type="button" class="packs__row-btn" (click)="openEditSubject(subject)"
                                  [attr.aria-label]="('COMMON.EDIT' | translate) + ' — ' + subject.name">
                            <i class="fa-solid fa-pen-to-square" aria-hidden="true"></i>
                            <span>{{ 'COMMON.EDIT' | translate }}</span>
                          </button>
                          <button type="button" class="packs__row-btn ps__row-btn--danger" (click)="deleteSubject(subject)"
                                  [attr.aria-label]="('COMMON.DELETE' | translate) + ' — ' + subject.name">
                            <i class="fa-solid fa-trash-can" aria-hidden="true"></i>
                            <span>{{ 'COMMON.DELETE' | translate }}</span>
                          </button>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </section>
        </div>
      } @else {
        <p class="packs__state">{{ 'PATH_SUBJECTS.SELECT_A_PATH' | translate }}</p>
      }
    </div>
  }

  <!-- Les champs d'un parcours, pour le parcours ouvert comme pour celui
       qu'on crée : un seul gabarit, deux brouillons. -->
  <ng-template #pathFields let-d let-target="target">
    <div class="packs__fields">
      <label class="packs__field ps__field--wide">
        <span>{{ 'DATA_TABLE.TITLE' | translate }} *</span>
        <input type="text" name="title" required minlength="3" maxlength="255"
               [ngModel]="d.title" (ngModelChange)="patchPath(target, { title: $event })" />
      </label>
      <label class="packs__field">
        <span>{{ 'I18N.TITLE_AR' | translate }}</span>
        <input type="text" name="titleAr" dir="rtl" maxlength="255"
               [ngModel]="d.titleAr" (ngModelChange)="patchPath(target, { titleAr: $event })" />
      </label>
      <label class="packs__field">
        <span>{{ 'I18N.TITLE_FR' | translate }}</span>
        <input type="text" name="titleFr" maxlength="255"
               [ngModel]="d.titleFr" (ngModelChange)="patchPath(target, { titleFr: $event })" />
      </label>
      <label class="packs__field">
        <span>{{ 'I18N.TITLE_EN' | translate }}</span>
        <input type="text" name="titleEn" maxlength="255"
               [ngModel]="d.titleEn" (ngModelChange)="patchPath(target, { titleEn: $event })" />
      </label>
    </div>
    <p class="packs__hint">{{ 'I18N.HINT' | translate }}</p>

    <div class="packs__fields">
      <label class="packs__field">
        <span>{{ 'ADMIN.LEVEL' | translate }}</span>
        <select name="level" [ngModel]="d.level" (ngModelChange)="patchPath(target, { level: $event })">
          <option [ngValue]="null">{{ 'ADMIN.LEVEL_NONE' | translate }}</option>
          @for (level of levels; track level) {
            <option [ngValue]="level">{{ cycleLabelKey(level) | translate }}</option>
          }
        </select>
      </label>
      <label class="packs__field">
        <span>{{ 'ADMIN.STATUS' | translate }}</span>
        <select name="status" [ngModel]="d.status" (ngModelChange)="patchPath(target, { status: $event })">
          <option value="published">{{ 'ADMIN.PUBLISHED' | translate }}</option>
          <option value="draft">{{ 'ADMIN.DRAFT' | translate }}</option>
          <!-- Un statut que le formulaire ne propose pas reste affiché et
               envoyé tel quel, tant qu'on n'en choisit pas un autre. -->
          @if (d.status !== 'published' && d.status !== 'draft') {
            <option [value]="d.status">{{ d.status }}</option>
          }
        </select>
      </label>
      <label class="packs__field packs__field--narrow">
        <span>{{ 'ADMIN.DURATION_HOURS' | translate }}</span>
        <input type="number" name="durationHours" min="0" max="1000" step="1"
               [ngModel]="d.durationHours" (ngModelChange)="patchPath(target, { durationHours: $event })" />
      </label>
    </div>
    <p class="packs__hint">{{ 'ADMIN.LEVEL_HINT' | translate }}</p>
  </ng-template>

  <!-- Nouveau parcours -->
  <dialog #pathDialog class="ps__dialog" (close)="newPath.set(null)">
    @if (newPath(); as fresh) {
      <form (ngSubmit)="createPath()">
        <h2 class="ps__dialog-title">{{ 'ADMIN.ADD_PATH' | translate }}</h2>
        <div class="ps__dialog-body">
          <ng-container *ngTemplateOutlet="pathFields; context: { $implicit: fresh, target: 'new' }" />
        </div>
        <footer class="ps__dialog-foot">
          <button type="button" class="packs__btn" (click)="closePathDialog()">
            {{ 'COMMON.CANCEL' | translate }}
          </button>
          <button type="submit" class="packs__btn packs__btn--primary" [disabled]="savingDialog()">
            {{ 'COMMON.SAVE' | translate }}
          </button>
        </footer>
      </form>
    }
  </dialog>

  <!-- Nouvelle matière, ou matière à modifier -->
  <dialog #subjectDialog class="ps__dialog" (close)="subjectForm.set(null)">
    @if (subjectForm(); as form) {
      <form (ngSubmit)="saveSubject()">
        <h2 class="ps__dialog-title">
          {{ (form.id === null ? 'ADMIN.ADD_SUBJECT' : 'ADMIN.EDIT_SUBJECT') | translate }}
        </h2>
        <div class="ps__dialog-body">
          <div class="packs__fields">
            <label class="packs__field ps__field--wide">
              <span>{{ 'ADMIN.SUBJECT_NAME' | translate }} *</span>
              <input type="text" name="name" required minlength="3" maxlength="255"
                     [ngModel]="form.draft.name" (ngModelChange)="patchSubjectDraft({ name: $event })" />
            </label>
            <label class="packs__field">
              <span>{{ 'I18N.NAME_AR' | translate }}</span>
              <input type="text" name="nameAr" dir="rtl" maxlength="255"
                     [ngModel]="form.draft.nameAr" (ngModelChange)="patchSubjectDraft({ nameAr: $event })" />
            </label>
            <label class="packs__field">
              <span>{{ 'I18N.NAME_FR' | translate }}</span>
              <input type="text" name="nameFr" maxlength="255"
                     [ngModel]="form.draft.nameFr" (ngModelChange)="patchSubjectDraft({ nameFr: $event })" />
            </label>
            <label class="packs__field">
              <span>{{ 'I18N.NAME_EN' | translate }}</span>
              <input type="text" name="nameEn" maxlength="255"
                     [ngModel]="form.draft.nameEn" (ngModelChange)="patchSubjectDraft({ nameEn: $event })" />
            </label>
            <label class="packs__field packs__field--narrow">
              <span>{{ 'ADMIN.DISPLAY_ORDER' | translate }}</span>
              <input type="number" name="displayOrder" min="0" step="1"
                     [ngModel]="form.draft.displayOrder" (ngModelChange)="patchSubjectDraft({ displayOrder: $event })" />
            </label>
          </div>
          <p class="packs__hint">{{ 'I18N.HINT' | translate }}</p>

          <label class="packs__check">
            <input type="checkbox" name="isActive"
                   [ngModel]="form.draft.isActive" (ngModelChange)="patchSubjectDraft({ isActive: $event })" />
            <span>{{ 'PATH_SUBJECTS.IS_ACTIVE' | translate }}</span>
          </label>
          <p class="packs__hint">{{ 'PATH_SUBJECTS.INACTIVE_HINT' | translate }}</p>
        </div>
        <footer class="ps__dialog-foot">
          <button type="button" class="packs__btn" (click)="closeSubjectDialog()">
            {{ 'COMMON.CANCEL' | translate }}
          </button>
          <button type="submit" class="packs__btn packs__btn--primary" [disabled]="savingDialog()">
            {{ 'COMMON.SAVE' | translate }}
          </button>
        </footer>
      </form>
    }
  </dialog>
</div>
